import _ from 'lodash';

import { RECIPIENT_COPIES_LABEL, RECIPIENT_COPY_LABEL } from 'constants/documents';

export const getRecipientCopiesCountLabel = count =>
  `${count} ${_.lowerFirst(count === 1 ? RECIPIENT_COPY_LABEL : RECIPIENT_COPIES_LABEL)}`;

export const getRecipientCopiesToggleLabel = ({ count, isExpanded }) =>
  `${isExpanded ? 'Hide' : 'Show'} ${getRecipientCopiesCountLabel(count)}`;
